var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileTop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 390,
    height: 274.5,
    viewBox: "0 0 390 274.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 97,
    width: 390,
    height: 274.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 390,
    height: 368.5,
    transform: "translate(98)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Scroll_Group_2",
    "data-name": "Scroll Group 2",
    transform: "translate(0 -97)",
    clipPath: "url(#clip-path)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Scroll_Group_1",
    "data-name": "Scroll Group 1",
    transform: "translate(-98)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M0,0H390V231L194,271.5,0,231Z",
    transform: "translate(98 97)",
    fill: "#eed03e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 98,
    cy: 98,
    r: 98,
    transform: "translate(367)",
    fill: "rgba(99,99,99,0.16)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 97.5,
    cy: 97.5,
    r: 97.5,
    transform: "translate(338.5 10.5)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 97.5,
    cy: 97.5,
    r: 97.5,
    transform: "translate(38.5 30.5)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeWidth: 1,
    strokeDasharray: "7 7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 98,
    cy: 98,
    r: 98,
    transform: "translate(0 108)",
    fill: "rgba(99,99,99,0.16)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileTop);
export default __webpack_public_path__ + "static/media/profileTop.5dcf18a9e4b12221ce5c15bba6ff7223.svg";
export { ForwardRef as ReactComponent };